function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 20l-9.5-7.125a1.25 1.25 0 01-.5-1V6.25A1.25 1.25 0 0111.25 5h17.5A1.25 1.25 0 0130 6.25v5.569a1.25 1.25 0 01-.496.997L20 20zM20 20l-9.5 7.125a1.25 1.25 0 00-.5 1v5.625A1.25 1.25 0 0011.25 35h17.5A1.25 1.25 0 0030 33.75v-5.569a1.25 1.25 0 00-.496-.997L20 20zM30 28.181l-20-.056",
  stroke: "#1B8388",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHourGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref);
}

export default SvgHourGlass;